export default __webpack_public_path__ + "static/simple-bubble-3b8b2fdbe476135c4fad438d4e13d412.png";